export interface ShuttleLocation {
  label: string;
  value: number;
}

export const CROSS_BORDER_XPRESS_LOCATION: ShuttleLocation = {
  label: 'CROSS BORDER XPRESS',
  value: 4,
};